const colors = {
  1: 'green',
  2: 'blue',
  3: 'red',
  4: 'gray',
  5:'lightgray',
  6: 'yellow',
} as const;
export type Color = typeof colors[keyof typeof colors];
export type ColorNumber = keyof typeof colors;

export const convert = (id: ColorNumber): Color => {
  return colors[id];
}
